import { createTransform } from "redux-persist"
import { getCartItem } from "../utils/getProduct"

const { createSlice } = require("@reduxjs/toolkit")

const initialState = {
  items: [],
}

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem(state, { payload }) {
      const item = state.items.find(item => item.id === payload.id)
      if (item) {
        item.quantity += payload.quantity
      } else {
        state.items.push({
          id: payload.id,
          type: payload.type,
          quantity: payload.quantity,
        })
      }
    },
    removeItem(state, { payload }) {
      state.items = state.items.filter(
        item => item.id !== payload.id && item.type !== payload.type
      )
    },
    clear() {
      return initialState
    },
  },
})

const { addItem, removeItem, clear } = cartSlice.actions

export const cartActions = {
  addItem,
  removeItem,
  clear,
}

export const cartSelectors = {
  items: state => state.cart.items,
  numItems: state => state.cart.items.length,
}

export const cartUtils = {
  itemInCart: id => state => state.cart.items.some(item => item.id === id),
  totalCost: getCartItem => state =>
    state.cart.items.reduce((total, { id, type, quantity }) => {
      const product = getCartItem({ id, type })
      return total + product.price * quantity
    }, 0),
}

const cartReducer = cartSlice.reducer

export const cartTransforms = {
  removeDeletedProductsFromCart: createTransform(
    null,
    outboundState => {
      return {
        ...outboundState,
        items: outboundState.items.filter(({ id, type }) =>
          Boolean(getCartItem({ id, type }))
        ),
      }
    },
    {
      whitelist: ["cart"],
    }
  ),
}

export default cartReducer
